import { HamburgerIcon } from '@chakra-ui/icons';
import { Box, Center } from '@chakra-ui/react';
import React from 'react';

export interface NavigationToggleProps {
    onOpen: () => void;
}

const NavigationToggle = (props: NavigationToggleProps) => {
    return (
        <Center paddingRight='20px'
                fontSize='3xl'>
            <Box
                as='button'
                onClick={props.onOpen}>
                <Center>
                    <HamburgerIcon />
                </Center>
            </Box>
        </Center>
    );
};

export default NavigationToggle;